module.exports = __webpack_public_path__ + "media/assets/images/flags/sr-d23bfe226d42d805b8c40b656271b7f3.svg";